import type { GoodsCoreModel, IScreensLogging } from '../../../../../api/types';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';

type LogOnGoodsPressItemProps = {
  item: GoodsCoreModel;
  screen?: string;
  logging: IScreensLogging;
};

export const logOnGoodsPressItem = ({
  item,
  screen,
  logging,
}: LogOnGoodsPressItemProps) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_GOODS',
    analytics: {
      ...(isNotNil(screen) && { SCREEN: screen }),
      ...logging.analytics,
    },
    ably_only_log: logging.ably_only_log,
  });

  bridge.logAdEvent({
    action: AdAction.CLICK,
    ad: item.ad,
  });
};
